import { render, staticRenderFns } from "./IconMask.vue?vue&type=template&id=39f07a80&"
import script from "./IconMask.vue?vue&type=script&lang=ts&"
export * from "./IconMask.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports